import { Box, Card, CardContent, CardHeader, Typography, Stack } from '@mui/material';
import { Field } from 'react-final-form';

import { TextField } from '@occc-app/design-system';

import {
  MAX_DEFAULT_SCREEN_NAME_LENGTH,
  MAX_DEFAULT_SCREEN_DESCRIPTION_LENGTH,
  DEFAULT_SCREEN_DETAILS_SECTION_TITLE,
  DEFAULT_SCREEN_NAME_LABEL,
  DEFAULT_SCREEN_DESCRIPTION_LABEL,
} from '../../touchpoint.constants';

export const DefaultScreenDetailsSection = () => {
  return (
    <Box mb={2}>
      <Card>
        <CardHeader
          title={
            <Typography variant='subtitle1' paragraph>
              {DEFAULT_SCREEN_DETAILS_SECTION_TITLE}
            </Typography>
          }
        />
        <CardContent>
          <Stack direction='row' spacing={3}>
            <Field name='name'>
              {({ input, meta }) => (
                <TextField
                  {...input}
                  label={DEFAULT_SCREEN_NAME_LABEL}
                  required
                  error={meta.touched && meta.error}
                  inputProps={{
                    maxLength: MAX_DEFAULT_SCREEN_NAME_LENGTH,
                  }}
                />
              )}
            </Field>
            <Field name='description'>
              {({ input, meta }) => (
                <TextField
                  {...input}
                  label={DEFAULT_SCREEN_DESCRIPTION_LABEL}
                  required
                  error={meta.touched && meta.error}
                  inputProps={{
                    maxLength: MAX_DEFAULT_SCREEN_DESCRIPTION_LENGTH,
                  }}
                />
              )}
            </Field>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};
